import AuthorizePage from "./onboarding/AuthorizePage";

const Onboarding = () => {
  return (
    <>
      <AuthorizePage />
    </>
  );
};

export default Onboarding;
